import { Skeleton } from "@/components/ui/skeleton";

const EsgDashboardSkeleton = () => (
  <div className="space-y-4">
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
      {Array.from({ length: 4 }).map((_, index) => (
        <div
          key={`esg-summary-${index}`}
          className="rounded-radius border border-border bg-card p-5"
        >
          <Skeleton className="h-4 w-24" />
          <Skeleton className="mt-3 h-8 w-20" />
          <Skeleton className="mt-2 h-3 w-28" />
        </div>
      ))}
    </div>

    <div className="rounded-radius border border-border bg-card p-5">
      <Skeleton className="h-5 w-48" />
      <Skeleton className="mt-2 h-3 w-64" />
      <Skeleton className="mt-4 h-64 w-full" />
    </div>

    <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={`esg-category-${index}`}
          className="rounded-radius border border-border bg-card p-5"
        >
          <Skeleton className="h-4 w-32" />
          <Skeleton className="mt-3 h-3 w-full" />
          <Skeleton className="mt-4 h-10 w-full" />
        </div>
      ))}
    </div>

    <div className="rounded-radius border border-border bg-card p-5">
      <Skeleton className="h-5 w-44" />
      <Skeleton className="mt-2 h-3 w-56" />
      <div className="mt-4 space-y-3">
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton key={`esg-completion-${index}`} className="h-20 w-full" />
        ))}
      </div>
    </div>
  </div>
);

export default EsgDashboardSkeleton;
